"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _highcharts = _interopRequireDefault(require("highcharts"));

var _reactJsxHighcharts = require("react-jsx-highcharts");

var _strings = require("../Voting/strings");

var _RatingFeedbackView = require("./RatingFeedbackView");

var _LiveTickerRating = require("./LiveTickerRating");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _Constants = require("../../constants/Constants");

function RatingPolarChart(_ref) {
  var group = _ref.group,
      questions = _ref.questions,
      feedbacks = _ref.feedbacks;
  var middleValues = feedbacks.map(function (feedback) {
    var votes = _LiveTickerRating.ratings.map(function (id) {
      return feedback && feedback.hasOwnProperty(id) ? feedback["".concat(id, "_abs")] : 0;
    });

    var _getEvaluation = (0, _RatingFeedbackView.getEvaluation)(votes),
        middleValue = _getEvaluation.middleValue;

    return Number(middleValue);
  });

  var isMobile = !_DeviceInfoHelper["default"].isBrowser() || _DeviceInfoHelper["default"].isBrowser() && window.innerWidth < _Constants.SMARTPHONE_WIDTH_PORTRAIT_BREAKPOINT;

  console.log('Rating', isMobile, window.innerWidth, _Constants.SMARTPHONE_WIDTH_PORTRAIT_BREAKPOINT);
  return /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.HighchartsChart, {
    polar: true,
    plotOptions: {
      series: {
        pointInterval: 1,
        pointStart: 0
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.Title, null, "".concat((0, _strings.getString)('EVALUATION'), ": ").concat(group)), /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.Pane, {
    size: '69%'
  }), /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.XAxis, {
    tickInterval: 1,
    min: 0,
    max: questions.length,
    categories: questions.map(function (q) {
      return q.label;
    }),
    labels: {
      distance: 0,
      reserveSpace: true,
      style: {
        fontSize: isMobile ? 8 : 11
      }
    },
    tickmarkPlacement: "on",
    lineWidth: 0
  }), /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.Tooltip, null), /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.YAxis, {
    min: 0,
    max: 5,
    tickInterval: 1,
    gridLineInterpolation: questions.length > 4 ? 'polygon' : 'circle'
  }, /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.AreaSeries, {
    name: (0, _strings.getString)('MIDDLEVALUE'),
    data: middleValues
  })));
}

RatingPolarChart.propTypes = {
  feedbacks: _propTypes["default"].array,
  questions: _propTypes["default"].array,
  group: _propTypes["default"].string
};

var _default = (0, _reactJsxHighcharts.withHighcharts)(RatingPolarChart, _highcharts["default"]);

exports["default"] = _default;